import { render } from "./CategoriesMatchStep.vue?vue&type=template&id=7b572a79&scoped=true"
import script from "./CategoriesMatchStep.vue?vue&type=script&lang=js"
export * from "./CategoriesMatchStep.vue?vue&type=script&lang=js"

import "./CategoriesMatchStep.vue?vue&type=style&index=0&id=7b572a79&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b572a79"]])

export default __exports__